import { Box, Typography } from "@mui/material";
import ImageLoader from "../Loader/ImageLoader";
import React, { useMemo, useState } from "react";

import "./about.css";

export default function About() {
  const [imageLoading, setImageLoading] = useState(true);
  const isMobile = window.innerWidth <= 768; 

  const experience = useMemo(() => {
    const startDate = new Date(2022, 5); // June 2022
    const now = new Date();

    const totalMonths =
      (now.getFullYear() - startDate.getFullYear()) * 12 +
      (now.getMonth() - startDate.getMonth());

    return Math.floor(totalMonths / 12);
  }, []);

  return (
    <section id="about">
      <Box className="mobile_about about-container">
        <Box className="salutation left" id={!isMobile ? "fromLeft" : ""}>
          {imageLoading && <ImageLoader />}

          <img
            className="object-[40%_30%]"
            src="/assets/about.png"
            alt="Ghulam Ullah"
            onLoad={() => setImageLoading(false)}
          />
        </Box>

        <Box>
          <Typography className="title" variant="h4" id={!isMobile ? "fromRight" : ""}>
            About
          </Typography>

          <Typography variant="h6" className="desc text-white mt-4" id={!isMobile ? "fromRight" : ""}>
            I'm a <strong>Full Stack Engineer</strong> with{" "}
            <strong>{experience}+ years of experience</strong> building scalable web
            applications and backend systems. I specialize in{" "}
            <strong>Node.js, React, Next.js, TypeScript</strong>, and modern cloud
            technologies, with a strong focus on clean architecture, API design,
            and performance. Throughout my career, I've contributed to products
            across <strong>fintech, education, healthcare, real estate, and sports</strong>,
            delivering reliable software for real businesses and users.
          </Typography>

          <Box className="skills-list mt-4" id={!isMobile ? "fromRight" : ""}>
            <Typography variant="h5" className="text-cyan-500 font-semibold">
              Core Expertise
            </Typography>

            <Box role="ul">
              <Typography variant="h6" className="desc text-white mt-4" role="li">
                <strong>Frontend:</strong> React.js, Next.js, TypeScript, Redux, Tailwind CSS, Material UI.
              </Typography>

              <Typography variant="h6" className="desc text-white mt-4" role="li">
                <strong>Backend:</strong> Node.js, Express.js, Laravel, REST APIs, GraphQL, Authentication.
              </Typography>

              <Typography variant="h6" className="desc text-white mt-4" role="li">
                <strong>Databases:</strong> MongoDB, PostgreSQL, MySQL.
              </Typography>

              <Typography variant="h6" className="desc text-white mt-4" role="li">
                <strong>Cloud & DevOps:</strong> AWS, Docker, DigitalOcean, Vercel, CI/CD, Nginx.
              </Typography>
            </Box>
          </Box>

          <Box className="projects-list mt-4" id={!isMobile ? "fromRight" : ""}>
            <Typography variant="h5" className="text-cyan-500 font-semibold">
              Highlights
            </Typography>

            <Box role="ul">
              <Typography role="li" variant="h6" className="desc text-white mt-4">
                Built and maintained scalable web applications serving multiple business domains.
              </Typography>

              <Typography role="li" variant="h6" className="desc text-white mt-4">
                Designed secure REST and GraphQL APIs with a focus on scalability and maintainability.
              </Typography>

              <Typography role="li" variant="h6" className="desc text-white mt-4">
                Delivered end-to-end solutions across frontend, backend, databases, and cloud infrastructure.
              </Typography>

              <Typography role="li" variant="h6" className="desc text-white mt-4">
                Experienced collaborating with cross-functional teams throughout the software development lifecycle.
              </Typography>
            </Box>
          </Box>

          <Typography variant="h6" className="desc text-white mt-4" id={!isMobile ? "fromRight" : ""}>
            I enjoy solving complex engineering challenges, continuously learning new technologies, and building software that is scalable, maintainable, and impactful.
          </Typography>
        </Box>
      </Box>
    </section>
  );
}